import { createTypes } from '../../shared/utils/createTypes';

export const ActionTypes = createTypes([
  'ADD_CAR_TO_COMPARISON',
  'REMOVE_CAR_FROM_COMPARISON',
]);
